import { Box, Flex, Grid, Switch, Text } from "@chakra-ui/react";
import { InputField } from "components/input-field";
import { useInputDelay } from "components/use-input-delay";
import { useState } from "react";
import { FiltersWhatsAppSessions } from "./types";

export function FiltrosWhatsAppSessions({
  setFilters,
  filters,
}: {
  setFilters: React.Dispatch<React.SetStateAction<FiltersWhatsAppSessions>>;
  filters: FiltersWhatsAppSessions;
}) {
  const [textSearch, setTextSearch] = useState("");

  useInputDelay(
    () => setFilters((prev) => ({ ...prev, text: textSearch })),
    [textSearch],
    1000
  );

  return (
    <Box w="100%">
      {/* <Text fontSize="20px" fontWeight="semibold" mb="10px">
        Filtros
      </Text> */}
      <Grid
        templateColumns="1fr 1fr 1fr"
        gap="25px"
        borderRadius="10px"
        flexDir="column"
        mb="30px"
      >
        <Box>
          <InputField
            title="Pesquisar"
            value={textSearch}
            onChange={(e) => setTextSearch(e.target.value)}
            inputProps={{
              placeholder: "Digite um nome ou telefone",
              variant: "outline-custom",
            }}
          />
        </Box>

        <Box>
          <Text mb="8px" fontWeight="medium">
            &nbsp;
          </Text>
          <Flex alignItems="flex-end" h="32px">
            <Switch
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  onlyDisconnected: !prev.onlyDisconnected,
                }))
              }
              isChecked={!!filters.onlyDisconnected}
            ></Switch>
            <Text ml="8px">Somente sessões não conectadas</Text>
          </Flex>
        </Box>
      </Grid>
    </Box>
  );
}
